<template>
    <div
        id="cz2__banner-ad--wrapper"
        class="cz2__banner-ad--wrapper"
    >
        <div
            v-if="staticContent"
            v-html="staticContent"
        />
    </div>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__banner-ad--wrapper {
            width: 100%;
            max-width: 968px;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                staticContent: null,
            };
        },

        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            globalSettingsController() {
                return this.$store.state.customizer.globalSettings;
            },
        },

        mounted() {
            // Get it from an attribute.
            if (this.globalSettingsController) {
                const content = this.globalSettingsController.blueprint?.custom?.['banner-ad-html'];

                if (content) {
                    this.staticContent = content;
                }
            }

            if (this.staticContent == null || this.staticContent.length === 0) {
                const bannerTemplate = document.querySelector('.py-splash-banner');

                if (bannerTemplate) {
                    let html = bannerTemplate.innerHTML;

                    if (html) {
                        html = html.trim();

                        if (html.length > 0) {
                            this.staticContent = html;
                        }
                    }
                }
            }
        },
    };
</script>
